module.exports = __webpack_public_path__ + "static/pattern-fdc24ba7751ef147c213b8e2c5fcc11d.jpg";